// ── Shared Date/Time Format Constants ──
// Used by both AdvancedFormatDialog and VariableFormDialog

// ── Timezone list (from Intl API) ──
export const TIMEZONE_OPTIONS: { display_label: string; api_name: string }[] = (() => {
  try {
    return Intl.supportedValuesOf('timeZone').map((tz) => ({
      display_label: tz,
      api_name: tz,
    }));
  } catch {
    // Fallback for older browsers
    const common = [
      'UTC', 'America/New_York', 'America/Chicago', 'America/Denver', 'America/Los_Angeles',
      'America/Sao_Paulo', 'Europe/London', 'Europe/Paris', 'Europe/Berlin', 'Europe/Moscow',
      'Asia/Dubai', 'Asia/Kolkata', 'Asia/Shanghai', 'Asia/Tokyo', 'Asia/Singapore',
      'Australia/Sydney', 'Pacific/Auckland', 'Africa/Cairo', 'Africa/Lagos',
    ];
    return common.map((tz) => ({ display_label: tz, api_name: tz }));
  }
})();

// ── Predefined date/time format presets (matching legacy app) ──
export const DATE_FORMAT_OPTIONS = [
  { display_label: 'DD/MM/YYYY    (25/12/2023)', api_name: 'DD/MM/YYYY' },
  { display_label: 'MM/DD/YYYY    (11/30/2023)', api_name: 'MM/DD/YYYY' },
  { display_label: 'DD-MM-YYYY    (01-01-2023)', api_name: 'DD-MM-YYYY' },
  { display_label: 'MMM D, YYYY   (Nov 30, 2023)', api_name: 'MMM D, YYYY' },
  { display_label: 'M/D/YY        (8/30/23)', api_name: 'M/D/YY' },
  { display_label: 'D/M/YY        (30/8/23)', api_name: 'D/M/YY' },
  { display_label: 'YYYY-MM-DD    (2023-07-01)', api_name: 'YYYY-MM-DD' },
  { display_label: 'DD.MM.YYYY    (01.01.2023)', api_name: 'DD.MM.YYYY' },
  { display_label: 'MMMM YYYY     (November 2023)', api_name: 'MMMM YYYY' },
  { display_label: 'Timestamp     (1701665275541)', api_name: 'timestamp' },
];

export const TIME_FORMAT_OPTIONS = [
  { display_label: 'HH:mm:ss Z   (12:03:00 +05:30)', api_name: 'HH:mm:ss Z' },
  { display_label: 'h:mm A       (1:06 PM)', api_name: 'h:mm A' },
  { display_label: 'h:mm A Z     (1:06 PM +05:30)', api_name: 'h:mm A Z' },
  { display_label: 'HH:mm Z      (12:03 +05:30)', api_name: 'HH:mm Z' },
  { display_label: 'HH:mm        (12:03)', api_name: 'HH:mm' },
  { display_label: 'hh:mm A      (01:06 PM)', api_name: 'hh:mm A' },
  { display_label: 'Timestamp    (1701665275541)', api_name: 'timestamp' },
];

export const DATETIME_FORMAT_OPTIONS = [
  { display_label: 'DD-MM-YYYY hh:mm A          (01-05-2023 12:06 PM)', api_name: 'DD-MM-YYYY hh:mm A' },
  { display_label: 'DD-MM-YYYY hh:mm A Z        (01-05-2023 12:06 PM +05:30)', api_name: 'DD-MM-YYYY hh:mm A Z' },
  { display_label: 'DD/MM/YYYY hh:mm A          (01/05/2023 12:06 PM)', api_name: 'DD/MM/YYYY hh:mm A' },
  { display_label: 'DD/MM/YYYY hh:mm A Z        (01/05/2023 12:06 PM +05:30)', api_name: 'DD/MM/YYYY hh:mm A Z' },
  { display_label: 'MM/DD/YYYY hh:mm:ss A Z     (05/31/2023 12:06:00 PM +5:30)', api_name: 'MM/DD/YYYY hh:mm:ss A Z' },
  { display_label: 'YYYY-MM-DD HH:mm Z          (2023-01-01 13:06 +05:30)', api_name: 'YYYY-MM-DD HH:mm Z' },
  { display_label: 'MMM D, h:mm A               (Nov 30, 12:06 PM)', api_name: 'MMM D, h:mm A' },
  { display_label: 'MM-DD-YYYY HH:mm            (11-30-2023 12:06)', api_name: 'MM-DD-YYYY HH:mm' },
  { display_label: 'ddd, D MMM YYYY h:mm A Z    (Thu, 30 Nov 2023 12:06 PM +05:30)', api_name: 'ddd, D MMM YYYY h:mm A Z' },
  { display_label: 'Timestamp                   (1701665275541)', api_name: 'timestamp' },
];

export function isDateTimeFormatType(formatType: string): boolean {
  return ['dateFormats', 'timeFormats', 'dateTimeFormats'].includes(formatType);
}

export function getFormatPresetOptions(formatType: string) {
  switch (formatType) {
    case 'dateFormats': return DATE_FORMAT_OPTIONS;
    case 'timeFormats': return TIME_FORMAT_OPTIONS;
    case 'dateTimeFormats': return DATETIME_FORMAT_OPTIONS;
    default: return [];
  }
}
